module.exports = __webpack_public_path__ + "./fonts/ProximaNova-LightItalic.otf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/proxima-nova/fonts/ProximaNova-LightItalic.otf
// module id = 441
// module chunks = 0 1 2 3 4 5 6